export const initialState = {
  // Retain this if other screens still use the global configuration.
  approvalConfigs: {
    mappingApprovalAvailable: false,
    dataApprovalAvailable: false,
  },

  // Drug-type-wise configuration
  drugTypes: [],

  apiStatus: {
    loader: false,
    message: null,
    next: false,
    data: [],
    apiError: false,
    apiSuccess: false,
  },
};